import * as types from '../actions/actionTypes';
import initalState from './initialState';

function getUpdatedRunsForPickupFromRun(state, update) {
  let {runId, response} = update;
  let items = [...state.items.map(run => {
    let runReturn = {...run};
    if (runReturn.id == runId) {
      runReturn = response;
    }
    return runReturn;
  })];
  return {items: items, loaded: state.loaded, dateFrom: state.dateFrom, dateTo: state.dateTo, selectedDriverId: state.selectedDriverId, selectedTypes: state.selectedTypes};
}

export default function runReducer(state = initalState.searchRuns, action){
  switch(action.type) {
    case types.LOAD_RUNS_SUCCESS:       
      return {...action.runs};
    case types.RUN_LOCATION_CHECKIN_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.checkIn);
    case types.RUN_LOCATION_TANK_PICKUP_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.update);
    case types.RUN_LOCATION_ADDNOTE_SUCCESS:
      return getUpdatedRunsForPickupFromRun(state, action.update);
    case types.LOAD_RUNS_FILTERCHANGED: {
      let newState = {
        ...state,
        isComplete: action.filter.isComplete,
        dateFrom: action.filter.dateFrom,
        dateTo: action.filter.dateTo,
        selectedDriverId: action.filter.selectedDriverId,
        selectedTypes: action.filter.selectedTypes,
        items: [],
      };     
      return newState;
    }
    default:
      return state;
  }
}
